import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => createStyles({
  apartmentSkeleton: {
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
    '& span.round': {
      borderRadius: '8px',
    },
    '& .row': {
      display: 'flex',
      justifyContent: 'space-between',
    },
  },
  labels: {
    display: 'flex',
    gap: '5px',
  },
  deal: {
    display: 'flex',
    padding: '8px 12px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    borderRadius: '12px',
    border: '1px solid #988BEE',
    backgroundColor: '#FBFAFE',
  },
}));
